import React from "react";
import Table from "../lms-customised-comps/Table";
import "../../../../styles/lead-mangement/lms-fd-reports.css";

const statCards = [
  {
    value: 342,
    valueClass: "kpi-value blue",
    label: "Total Follow-ups",
    change: "+12% from last month",
    changeClass: "kpi-change green",
  },
  {
    value: "₹6.7L",
    valueClass: "kpi-value red",
    label: "Missed Follow-ups Value",
    change: "18 missed calls",
    changeClass: "kpi-change red",
  },
  {
    value: "68%",
    valueClass: "kpi-value green",
    label: "Follow-up Conversion",
    change: "+5% improvement",
    changeClass: "kpi-change green",
  },
  {
    value: "₹38.5L",
    valueClass: "kpi-value purple",
    label: "Total Revenue",
    change: "This month",
    changeClass: "kpi-change purple",
  },
];

const tableColumns = [
  {
    key: "agent",
    header: "Agent Name",
    render: (row) => (
      <span className={`bold-600 ${row.rateColor}`}>{row.agent}</span>
    ),
  },
  { key: "assigned", header: "Assigned Leads" },
  { key: "conversions", header: "Conversions" },
  {
    key: "rate",
    header: "Conversion Rate",
    render: (row) => (
      <span className={`conversion-badge ${row.rateColor}`}>{row.rate}</span>
    ),
  },
  { key: "revenue", header: "Revenue Generated" },
  { key: "duration", header: "Avg. Call Duration" },
];

const tableData = [
  {
    agent: "Priya Singh",
    assigned: 85,
    conversions: 23,
    rate: "27.1%",
    rateColor: "green",
    revenue: "₹14.2L",
    duration: "8.5 min",
  },
  {
    agent: "Amit Kumar",
    assigned: 72,
    conversions: 19,
    rate: "26.4%",
    rateColor: "green",
    revenue: "₹11.8L",
    duration: "7.2 min",
  },
  {
    agent: "Kavya Reddy",
    assigned: 68,
    conversions: 15,
    rate: "22.1%",
    rateColor: "yellow",
    revenue: "₹9.5L",
    duration: "6.8 min",
  },
];

const LMSFDReports = () => {
  return (
    <div className="fd-reports-main-container">
      {/* Title */}
      <div className="fd-reports-title-row">
        <span className="fd-reports-title-icon">📈</span>
        <span className="fd-reports-title">
          Performance Reports & Analytics
        </span>
      </div>

      {/* KPI Cards */}
      <div className="kpi-grid">
        {statCards.map((card, idx) => (
          <div className="kpi-card" key={idx}>
            <div className={card.valueClass}>{card.value}</div>
            <div className="kpi-label">{card.label}</div>
            <div className={card.changeClass}>{card.change}</div>
          </div>
        ))}
      </div>

      {/* Table Title */}

      {/* Table */}
      <div className="fd-reports-table-wrapper">
        <div className="fd-reports-table-title">Agent Performance Metrics</div>

        <Table columns={tableColumns} data={tableData} />
      </div>
    </div>
  );
};

export default LMSFDReports;
